import { useMutation, useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";

export type UkvdVehicleRow = {
  // shape for future search results; keep minimal for now
  uvc?: string;
  make?: string;
  range?: string;
  model?: string;
  fuelType?: string;
  engineCapacityCC?: number | string | null;
  kw?: number | string | null;
  bhp?: number | string | null;
  // engineCode?: string | null;
  transmissionType?: string | null;
  startDate?: string | null;
  endDate?: string | null;
};

export default function useUkvdLookup(customerId?: string, make?: string) {
  const { get } = useApiHelper();

  const makes = useQuery({
    queryKey: ["ukvd", "makes", customerId],
    enabled: !!customerId,
    queryFn: () => get<string[]>(`/vehiclelookup/makes`)
  });

  const ranges = useQuery({
    queryKey: ["ukvd", "ranges", customerId, make],
    enabled: !!customerId && !!make,
    queryFn: () =>
      get<string[]>(
        `/vehiclelookup/makes/${encodeURIComponent(make!)}/ranges`
      ),
  });

  // Placeholder until vehicles endpoint goes live
  const search = useMutation({
    mutationFn: async (args: { make: string; range: string; engineCode?: string }) => {
      try {
        const res = await get<UkvdVehicleRow[]>(
          `/vehiclelookup/vehicles?make=${encodeURIComponent(args.make)}&range=${encodeURIComponent(
            args.range
          )}&engineCode=${encodeURIComponent(args.engineCode ?? "")}`
        );
        return res;
      } catch {
        return [] as UkvdVehicleRow[];
      }
    },
  });

  return { makes, ranges, search };
}
